import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Spin,
  Switch,
  Upload,
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { SEditor } from 'shj-components'
import dayjs from 'dayjs'
import { cloneDeep, isArray, isEmpty } from 'lodash-es'
import { baseURL } from '@/api'
import { getToken } from '@/common/utils.ts'
import { uploadFile } from '@/services'
import {
  addOrEditeDealkingTalkOrderHomeConfDtl,
  addMultipleDealkingTalkOrderHomeConfDtl,
} from '@/services/talkOrder.ts'
import arrToListOption from '@/utils/arrToListOption'
import { isNilOrNull } from '@/utils'
import { fetchAllList } from '@/services'
import { DndContext, PointerSensor, useSensor } from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { getXTransferInsideTenantId } from '@/utils/common'
import { useFileUrlPrefix } from 'shj-utils'

const { Option } = Select
const { RangePicker } = DatePicker

const DraggableUploadListItem = ({ originNode, file }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: file.uid,
  })
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    cursor: 'move',
  }
  return (
    <div
      ref={setNodeRef}
      style={style}
      // prevent preview event when drag end
      className={isDragging ? 'is-dragging' : ''}
      {...attributes}
      {...listeners}
    >
      {/* hide error tooltip when dragging */}
      {file.status === 'error' && isDragging ? originNode.props.children : originNode}
    </div>
  )
}

export const AddOrEditAdvertDom: React.FC<any> = forwardRef(({ record, fn, ...rest }, ref) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState<any>([])
  const [acceptType, setAcceptType] = useState<string | undefined>(undefined)
  const [uploadDisabled, setUploadDisabled] = useState(true)
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [editorState, seteditorState] = useState(null)
  const [companyList, setCompanyList] = useState<any>([])
  const [imagePrefix] = useFileUrlPrefix()

  const uploadFileUrl = baseURL + `file-web/file/upload`

  useEffect(() => {
    initList()
  }, [])

  const initList = () => {
    getCompanyListData()
    if (record?.id) {
      const obj: any = {}
      obj.response = {}
      obj.response.data = {}
      obj.response.data.url = record?.fileUrl
      const nameArr = record?.fileUrl?.split('/')
      obj.response.data.name = nameArr?.[nameArr?.length - 1]

      setFileList([
        {
          uid: '1',
          name: nameArr?.[nameArr?.length - 1],
          url: record?.fileUrl?.startsWith('http')
            ? record?.fileUrl
            : imagePrefix + record?.fileUrl,
          status: 'done',
          // type: record?.fileType === 'img' ? `image/${typeArr?.[typeArr?.length - 1]}` : `${record?.fileType}/${typeArr?.[typeArr?.length - 1]}`,
          ...obj,
        },
      ])
      console.log(record, 'init')

      let confDtlRelWlistsList: any = []

      if (isArray(record?.confDtlRelWlists)) {
        record?.confDtlRelWlists.map(item => {
          confDtlRelWlistsList.push({ value: item.companyId, label: item.companyName })
        })
      }
      form?.setFieldsValue({
        ...record,
        confDtlRelWlists: record?.confDtlRelWlists ? confDtlRelWlistsList : null,
        startTime: record?.startTime
          ? [dayjs(record?.startTime), dayjs(record?.endTime)]
          : undefined,
      })
      setAcceptType(record?.fileType === 'img' ? 'image' : record?.fileType)
      if (!isNilOrNull(record?.remark)) {
        seteditorState(record?.remark)
      }
      setUploadDisabled(!record?.fileType)
    }
  }

  const sensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 10,
    },
  })
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setFileList(prev => {
        const activeIndex = prev.findIndex(i => i.uid === active.id)
        const overIndex = prev.findIndex(i => i.uid === over?.id)
        return arrayMove(prev, activeIndex, overIndex)
      })
    }
  }

  const getCompanyListData = () => {
    fetchAllList('company').then((data: any[]) => {
      setCompanyList(data || [])
    })
  }

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      if (loading) {
        reject({})
        return false
      }
      setLoading(true)
      form
        .validateFields()
        .then(values => {
          try {
            const newValues = cloneDeep(values)
            if (record?.id) newValues.id = record?.id
            newValues.parentId = rest?.pid
            newValues.parentName = rest?.parentName
            console.log(newValues, '提交')

            if (!isEmpty(newValues?.confDtlRelWlists)) {
              let confDtlRelWlistsList: any = []
              newValues?.confDtlRelWlists.map(item => {
                confDtlRelWlistsList.push({ companyId: item.value, companyName: item.label })
              })
              newValues.confDtlRelWlists = confDtlRelWlistsList
            }

            if (!isNilOrNull(editorState)) {
              newValues.remark = editorState
            } else {
              delete newValues.remark
            }
            if (fileList?.[0]?.status !== 'done') {
              setLoading(false)
              reject({ msg: '操作失败' })
              return message.warning('素材还未上传完成')
            }
            if (record?.id || acceptType !== 'image') {
              newValues.fileUrl = fileList?.[0]?.response?.data?.filePath || fileList?.[0]?.response?.data?.url
            } else {
              const list = fileList?.map((file: any, index: number) => {
                return {
                  fileUrl: file?.response?.data?.filePath || file?.url,
                  sortNumber: index + 1,
                }
              })
              newValues.dtlList = list
              newValues.fileUrl = null
            }
            if (newValues?.startTime) {
              newValues.endTime = values?.startTime?.[1]?.format('YYYY-MM-DD HH:mm:ss')
              newValues.startTime = values?.startTime?.[0]?.format('YYYY-MM-DD HH:mm:ss')
            }
            newValues.status = values?.status || false
            // console.log('newValues-----------',newValues)
            // return
            if (record?.id || acceptType !== 'image') {
              addOrEditeDealkingTalkOrderHomeConfDtl(newValues)
                .then((res: any) => {
                  message.success('操作成功')
                  setLoading(false)
                  resolve({})
                })
                .catch(() => {
                  setLoading(false)
                  reject({ msg: '操作失败' })
                })
            } else {
              addMultipleDealkingTalkOrderHomeConfDtl(newValues)
                .then((res: any) => {
                  message.success('操作成功')
                  setLoading(false)
                  resolve({})
                })
                .catch(() => {
                  setLoading(false)
                  reject({ msg: '操作失败' })
                })
            }
          } catch (err) {
            setLoading(false)
            reject(err)
          }
        })
        .catch(err => {
          setLoading(false)
          reject(err)
        })
    })
  }

  // 上传文件限制
  const beforeUpload = (file: any) => {
    const type = file?.type?.split('/')?.[0]
    const isFlag = type !== acceptType
    if (isFlag) {
      message.error(`文件格式有误，请重新上传`)
    }
    return !isFlag || Upload.LIST_IGNORE
  }

  const handleChange = ({ fileList }) => {
    setFileList(fileList)
  }

  const previewFile = (file: any) => {
    const url = file?.response?.data?.filePath || file?.response?.data?.url
    url?.startsWith('http')
    setPreviewOpen(true)
    setPreviewImage(url?.startsWith('http') ? url : imagePrefix + url)
  }

  const changeEditor = (editorState: any) => {
    seteditorState(editorState)
  }

  const onEditorUpload = async obj => {
    const { blobInfo, success, failure, progress } = obj
    var dataForm = new FormData()
    dataForm.append('file', blobInfo.blob(), blobInfo.filename())
    let res = await uploadFile(dataForm)
    success(`${res?.url}`)
  }

  useImperativeHandle(
    ref,
    () => ({
      onFinish,
    }),
    [onFinish]
  )

  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          label="描述信息"
          name="descInfo"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Input placeholder="请输入描述信息" maxLength={20} />
        </Form.Item>
        <Form.Item label="有效时间段" name="startTime">
          <RangePicker
            style={{ width: '100%' }}
            showTime={{
              defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('11:59:59', 'HH:mm:ss')],
            }}
          />
        </Form.Item>
        <Form.Item label="白名单" name="confDtlRelWlists">
          <Select
            placeholder="请选择白名单"
            allowClear
            showSearch
            optionFilterProp="children"
            mode="multiple"
            labelInValue
          >
            {/* {arrToListOption(companyList, { value: 'code', title: 'name' })} */}
            {companyList.map((item, index) => (
              <Select.Option key={index + item.id} value={item.id} data={item}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="排序" name="sortNumber">
          <InputNumber style={{ width: '100%' }} min={0} max={9999} />
        </Form.Item>
        <Form.Item label="是否启用" name="status" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          label="素材类型"
          name="fileType"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Select
            placeholder="请选择素材类型"
            allowClear
            onChange={(value: string) => {
              if (value === 'img') setAcceptType('image')
              else setAcceptType(value)
              setFileList([])
              // form.setFieldsValue({fileUrl: undefined})
              setUploadDisabled(false)
            }}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option: any) =>
              option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
            }
          >
            {rest?.fileTypeList?.map((item: any) => {
              return (
                <Option key={item.key} value={item.key}>
                  {item.description}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
        <DndContext sensors={[sensor]} onDragEnd={onDragEnd}>
          <SortableContext items={fileList.map(i => i.uid)} strategy={verticalListSortingStrategy}>
            <Form.Item
              label="素材"
              name="fileUrl"
              rules={[
                { required: true, message: '不能为空' },
                // () => ({
                //   validator(_, value) {
                //     const {file} = value
                //     // if (!isFlag) return Promise.resolve()
                //     // return Promise.reject(new Error('文件格式有误，请重新上传！'));
                //   },
                // }),
              ]}
              initialValue={fileList}
            >
              <Upload
                fileList={fileList}
                action={uploadFileUrl}
                listType="text"
                accept={`${acceptType}/*`}
                beforeUpload={beforeUpload}
                name="file"
                multiple={record?.id || acceptType !== 'image' ? false : true}
                onPreview={previewFile}
                disabled={uploadDisabled}
                onChange={handleChange}
                itemRender={(originNode, file) => (
                  <DraggableUploadListItem originNode={originNode} file={file} />
                )}
                headers={{
                  Authorization: getToken(),
                  'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId(),
                }}
              >
                {(record?.id || acceptType !== 'image') && fileList.length >= 1 ? null : (
                  <Button disabled={uploadDisabled} icon={<UploadOutlined />}>
                    上传
                  </Button>
                )}
                {acceptType === 'image' && (
                  <span style={{ color: 'red', marginLeft: '10px' }}>
                    图片只支持上传jpg、png、jpeg格式
                  </span>
                )}
              </Upload>
            </Form.Item>
          </SortableContext>
        </DndContext>
        <Form.Item label="备注" name="remark">
          <SEditor
            value={editorState}
            onChange={changeEditor}
            onUpload={onEditorUpload}
            toolbar="fullscreen | undo redo | styleselect fontselect fontsizeselect | bold italic lineheight strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify  | numlist bullist | indent2em outdent indent | subscript superscript | charmap image removeformat | link"
          />
        </Form.Item>
      </Form>
      <Modal
        open={previewOpen}
        title="预览"
        footer={null}
        onCancel={() => {
          setPreviewOpen(false)
        }}
      >
        {acceptType === 'image' ? (
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        ) : null}
        {acceptType === 'video' ? (
          <video controls={true} style={{ width: '100%' }} src={previewImage} />
        ) : null}
        {acceptType === 'audio' ? (
          <audio src={previewImage} controls={true} style={{ width: '100%' }} />
        ) : null}
      </Modal>
    </Spin>
  )
})
